import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import colors from "backpack-ui/dist/styles/colors";
import propTypes from "backpack-ui/dist/utils/propTypes";
import {
  fontSizeUppercase,
  fontWeightMedium,
  lineHeightReset,
} from "backpack-ui/dist/styles/typography";

const styles = {
  container: {
    display: "inline-block",
    textAlign: "center",
  },

  button: {
    alignItems: "center",
    border: "2px solid currentColor",
    borderRadius: "4px",
    color: "currentColor",
    display: "inline-flex",
    fontSize: `${fontSizeUppercase}px`,
    fontWeight: fontWeightMedium,
    height: "24px",
    justifyContent: "center",
    lineHeight: lineHeightReset,
    // marginLeft: "auto",
    // marginRight: "auto",
    textAlign: "center",
    textTransform: "uppercase",
    width: "98px",
  },

  text: {
    color: "currentColor",
    fontSize: `${fontSizeUppercase}px`,
    lineHeight: (16 / fontSizeUppercase),
    marginBottom: "20px",
    marginTop: "8px",
    paddingLeft: "12px",
    paddingRight: "12px",
  },
};

const types = {
  noDates: {
    button: "Select dates",
    message: "Select the dates and see prices.",
    color: colors.linkPrimary,
  },
  soldOut: {
    button: "Unavailable",
    message: "Please modify your filter selection.",
    color: colors.accentRed,
  },
};

const ListItemHotelCallToAction = ({
  onClick,
  type,
  style,
  styleText,
}) => (
  <div
    style={[
      styles.container,
      { color: types[type].color },
      style,
    ]}
    onClick={onClick}
  >
    <div style={styles.button}>
      {types[type].button}
    </div>

    <p style={[styles.text, styleText]}>
      {types[type].message}
    </p>
  </div>
);

ListItemHotelCallToAction.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["noDates", "soldOut"]).isRequired,
  style: propTypes.style,
  styleText: propTypes.style,
};

export default radium(ListItemHotelCallToAction);



// WEBPACK FOOTER //
// ./assets/pois/components/listItemHotel/callToAction.jsx